export const clearNameFromLeadingTrailingQuotes = (str) => {
  let name = str.trim()
  if (name.indexOf('«') === 0) {
    name = name.substring(1)
    if (name.indexOf('»') === name.length - 1) {
      name = name.substring(0, name.length - 1)
    }
  }

  if (name.indexOf('&laquo;') === 0) {
    name = name.substring(7)
    if (name.indexOf('&raquo;') === name.length - 7) {
      name = name.substring(0, name.length - 7)
    }
  }
  return name;
}

/**
 * Склоняет слово в зависимости от числа
 * @param {number} count - количество
 * @param {Array} words - варианты слов в формате [один, два, пять]
 * @return {string} - склоненное слово
 */
export const plural = (count, words) => {
  // Проверяем, что массив words содержит 3 элемента
  if (words.length !== 3) {
    throw new Error('Массив words должен содержать 3 формы слова');
  }

  // Получаем последние 2 цифры числа
  const mod100 = Math.abs(count) % 100;
  const mod10 = mod100 % 10;

  if (mod100 > 10 && mod100 < 20) return words[2];
  if (mod10 > 1 && mod10 < 5) return words[1];
  if (mod10 === 1) return words[0];
  return words[2];
};


/**
 *
 * @param { string } str
 * @return { string }
 */
export const ucFirst = (str) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}



// WEBPACK FOOTER //
// ./src/shared/helper/string.js